class TrueStoneCartOrderGuide extends HTMLElement {
  connectedCallback() {
    if (this.dataset.hasGift !== 'true' || this.ready) return;
    this.ready = true;
    this.fields = Array.from(this.querySelectorAll('[data-gift-field]'));
    this.status = this.querySelector('.ts-cart-guide__status');
    this.summary = this.querySelector('[data-gift-summary]');
    this.saveButton = this.querySelector('.ts-cart-guide__save');
    this.addEventListener('change', event => { if (event.target.matches('[data-gift-field]')) event.stopPropagation(); });
    this.addEventListener('input', event => {
      if (!event.target.matches('[data-gift-field]')) return;
      this.updateSummary();
      this.setStatus('Recipient changes are not saved yet.');
    });
    this.saveButton.addEventListener('click', () => this.saveRecipient());
    this.querySelector('.ts-cart-guide__clear')?.addEventListener('click', async () => {
      if (this.pending) await this.pending;
      this.fields.forEach(field => { if (field.dataset.giftField !== 'country') field.value = ''; });
      this.updateSummary();
      if (await this.saveRecipient(false)) this.setStatus('Recipient cleared. Add the new recipient before checking out.');
    });
    this.onQuantityChange = async event => {
      if (this.replayingQuantity || event.target.name !== 'updates[]') return;
      event.stopImmediatePropagation();
      const target = event.target;
      if (!await this.saveRecipient(false)) return;
      this.replayingQuantity = true;
      target.dispatchEvent(new Event('change', {bubbles:true}));
      this.replayingQuantity = false;
    };
    document.addEventListener('change', this.onQuantityChange, true);
    this.onCheckout = async event => {
      if (event.target.id !== 'cart' || !event.submitter || (event.submitter.name !== 'checkout' && event.submitter.id !== 'checkout')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const address = await this.saveRecipient();
      if (!address) return;
      const query = new URLSearchParams();
      Object.entries(address).forEach(([key, value]) => query.set('checkout[shipping_address][' + key + ']', value));
      window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout?' + query.toString());
    };
    document.addEventListener('submit', this.onCheckout, true);
    this.updateSummary();
  }
  disconnectedCallback() {
    if (this.onCheckout) document.removeEventListener('submit', this.onCheckout, true);
    if (this.onQuantityChange) document.removeEventListener('change', this.onQuantityChange, true);
  }
  updateSummary() {
    const values = Object.fromEntries(this.fields.map(field => [field.dataset.giftField, field.value.trim()]));
    const name = [values.first_name, values.last_name].filter(Boolean).join(' ');
    const locality = [values.city, values.province, values.zip].filter(Boolean).join(', ');
    this.summary.textContent = [name, values.address1, values.address2, locality, values.country].filter(Boolean).join('\n');
    if (!name && !values.address1) this.summary.textContent = 'Add the recipient’s name and delivery address above.';
  }
  setStatus(message, error = false) {
    this.status.textContent = message;
    this.status.dataset.error = String(error);
  }
  async saveRecipient(validate = true) {
    if (this.pending) { await this.pending; return this.saveRecipient(validate); }
    for (const field of this.fields) {
      field.value = field.value.trim();
      if (validate && !field.reportValidity()) { this.setStatus('Please complete the recipient’s delivery details.', true); return null; }
    }
    const address = Object.fromEntries(this.fields.map(field => [field.dataset.giftField, field.value]));
    let attributes = {};
    try { attributes = JSON.parse(this.dataset.cartAttributes || '{}'); } catch (_) {}
    this.fields.forEach(field => { const key = /^attributes\[(.*)\]$/.exec(field.name)?.[1]; if (key) attributes[key] = field.value; });
    this.setStatus('Saving recipient…');
    this.saveButton.disabled = true;
    this.fields.forEach(field => { field.disabled = true; });
    this.pending = (async () => {
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({attributes})});
        if (!response.ok) throw new Error('save');
        const result = await response.json();
        if (!result.attributes || (result.attributes['Gift recipient first name'] || '') !== address.first_name || (result.attributes['Gift delivery street'] || '') !== address.address1) throw new Error('verify');
        this.dataset.cartAttributes = JSON.stringify(result.attributes);
        this.setStatus('Gift recipient saved. Review these details again at checkout.');
        this.updateSummary();
        return address;
      } catch (_) {
        this.setStatus('We couldn’t save the gift recipient. Please try again before checking out.', true);
        return null;
      } finally {
        this.saveButton.disabled = false;
        this.fields.forEach(field => { field.disabled = false; });
        this.pending = null;
      }
    })();
    return this.pending;
  }
}
if (!customElements.get('ts-cart-order-guide')) customElements.define('ts-cart-order-guide', TrueStoneCartOrderGuide);